import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/var/www/proflow360/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/app/components/LandingFooter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/proflow360/src/app/components/PublicHero.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/proflow360/src/i18n/react.tsx");
